import { useEffect } from 'react'

/**
 * The right dock's width on the panes, while a dock is mounted: #bar / #term / #status / #footbar (and the corner
 * buttons) read `--fs-dock` and shrink by it, so the terminal refits beside the dock instead of being covered.
 *
 * Only on a wide screen. Squeezing works when there is room to give — the owner likes it there — but on a 412px phone a
 * 340px dock leaves the terminal about seventy pixels wide, which is not a narrower view of the terminal, it is no
 * terminal. Under 900px a dock overlays instead (see shell.css) and the panes keep their full width, so the variable
 * must not be set at all: leaving it set would shrink them behind the overlay, and you would find the terminal reflowed
 * when you closed it again.
 *
 * The file browser docks here. The session's whiteboard does not: it covers the session (board/BoardDrawer), so it
 * squeezes nothing, and App never has both out (a dock that unmounts takes the variable with it).
 */
export function useDockWidth(width: string): void {
  useEffect(() => {
    const el = document.documentElement
    const mq = window.matchMedia('(min-width: 900px)')
    const apply = () => {
      if (mq.matches) el.style.setProperty('--fs-dock', width)
      else el.style.removeProperty('--fs-dock')
    }
    apply()
    mq.addEventListener('change', apply)
    return () => {
      mq.removeEventListener('change', apply)
      el.style.removeProperty('--fs-dock')
    }
  }, [width])
}
